import "./ArcFlashLabels2.module.css";
import Header from "@/reusable_sections/Header";
import DirectAnswerBlock from "./sections/DirectAnswerBlock";
import WhatIsAnArcFlashLabel from "./sections/WhatIsAnArcFlashLabel";
import WhatInformationGoesOnAnArcFlashLabel from "./sections/WhatInformationGoesOnAnArcFlashLabel";
import EngravedPrintedStockOrCustom from "./sections/EngravedPrintedStockOrCustom";
import WhichStandardsApplyToArcFlashLabels from "./sections/WhichStandardsApplyToArcFlashLabels";
import WhoOrdersArcFlashLabelsFromEvermark from "./sections/WhoOrdersArcFlashLabelsFromEvermark";
import HowDoYouOrderArcFlashLabels from "./sections/HowDoYouOrderArcFlashLabels";
import ArcFlashLabelsCommonQuestions from "./sections/ArcFlashLabelsCommonQuestions";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function ArcFlashLabels2Page() {
  return <div>
      <Header />
      <DirectAnswerBlock />
      <WhatIsAnArcFlashLabel />
      <WhatInformationGoesOnAnArcFlashLabel />
      <EngravedPrintedStockOrCustom />
      <WhichStandardsApplyToArcFlashLabels />
      <WhoOrdersArcFlashLabelsFromEvermark />
      <HowDoYouOrderArcFlashLabels />
      <ArcFlashLabelsCommonQuestions />
      <ClosingCta />
      <Footer />
    </div>;
}